import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="text-center text-lg-start footerbgcolor mt-3">
            <div className="container p-4" style={{ height: 170, bottom: 20 }}>
                <div className="row">
                    
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase" style={{ color: "white" }}>HELP AND SUPPORT</h5>
                        <ul className="list-unstyled mt-3">
                            <li><Link to="/reach-us" className="text-white">REACH US</Link></li>
                            <li><Link to="/raise-request" className="text-white">RAISE A REQUEST</Link></li>
                        </ul>
                    </div>

                
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase" style={{ color: "white" }}>CONNECT WITH US</h5>
                        <h2>
                            <a href="https://www.facebook.com/rpsmartenergy2021/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-square-facebook socialmediaicon"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/rp-smart-energy" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin ms-2"></i>
                            </a>
                            <a href="https://www.instagram.com/rpsmartenergy2021/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram ms-2"></i>
                            </a>
                            <a href="https://x.com/RP_SMART_ENERGY" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-x-twitter ms-2"></i>
                            </a>
                            <a href="https://www.youtube.com/@rpsmartenergy" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-youtube ms-2"></i>
                            </a>
                            <a href="https://api.whatsapp.com/send?phone=919994356072" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-whatsapp ms-2"></i>
                            </a>
                        </h2>
                        <ul className="list-unstyled mb-0 text-white">
                            <li><i className='fa-solid fa-phone'></i>04294-235499</li>
                            <li><i className="fa-sharp fa-solid fa-mobile"></i> +91 99943 56072</li>
                            <li><i className="fa-solid fa-envelope"></i> admin@rpsmartsolar.in</li>
                        </ul>
                    </div>

                    
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase mb-0" style={{ color: "white" }}>ADDRESS</h5>
                        <ul className="list-unstyled mt-3 text-white">
                            <li>19/1, AAYAPARAPPU, KANJIKOVIL,</li>
                            <li>PERUNDURAI (TK), ERODE (DT),</li>
                            <li>TAMILNADU - 638116.</li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3911.8453356947957!2d77.60030927486561!3d11.346005288839526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96dfdb96e5ce1%3A0x98b4f317d24ef86e!2sRP%20SMART%20ENERGY!5e0!3m2!1sen!2sin!4v1721815178808!5m2!1sen!2sin"
                            className="rounded"
                            width="200"
                            height="130"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="RP Smart Energy Location"
                        ></iframe>
                    </div>
                </div>
            </div>

            <div className="text-center text-white py-2" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
            <div>Copy Rights © 2025 RP Smart Energy, All Rights Reserved.</div>
            <div>
                Powered by{" "}
                <a
                href="https://rpsoftwares.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ffa73c", textDecoration: "none", fontWeight: "bold" }}
                >
                RP Software Solutions
                </a>
            </div>
            </div>
        </footer>
    );
}

export default Footer;